/**
 * ms-graph-api.ts — typed facade for the four Microsoft/Graph-log ops
 * IntegrationDetail consumes. These ops shipped in a kit (ebcdff34 Part B/C)
 * this doc's api-client build does not yet export, so a static named import
 * fails the strict tsc gate. This facade resolves them off the api-client
 * namespace at call time: present → the real op runs; absent → an honest
 * thrown error the screen's existing catch paths already render (no fake
 * success, behavior identical to the previous undefined-import failure mode).
 * Delete when the kit's api-client exports these four (tracked with REQ-061).
 */
import * as api from "@v0y4ge/api-client";

type AnyOp = (...args: unknown[]) => Promise<unknown>;
function op(name: string): AnyOp {
  return async (...args: unknown[]) => {
    const f = (api as unknown as Record<string, unknown>)[name];
    if (typeof f !== "function") throw new Error(`${name} is not available in this @v0y4ge/api-client build (kit op pending)`);
    return (f as AnyOp)(...args);
  };
}

export const getGraphLogSettings = op("getGraphLogSettings");
/** GET …/microsoft/graph-logs/{id} — one row with decrypted request_body / response_body (strings or null). */
export const getGraphApiLogDetail = op("getGraphApiLogDetail");
export const updateGraphLogSettings = op("updateGraphLogSettings");
export const getMicrosoftStatus = op("getMicrosoftStatus");
export const verifyMicrosoftConnection = op("verifyMicrosoftConnection");
/** PATCH /v1/admin/integrations/microsoft/settings (`sender`, `senderDisplayName`; CC 0132). */
export const updateMicrosoftSettings = op("updateMicrosoftSettings");
/** GET /v1/admin/integrations/microsoft/groups (CC 0157). */
export const listMicrosoftEntraGroups = op("listMicrosoftEntraGroups");
/** GET /v1/admin/integrations/microsoft/settings (`sender`, `senderDisplayName`). */
export const getMicrosoftSettings = op("getMicrosoftSettings");
/** POST /v1/admin/integrations/microsoft/user-sync/run (CC 0165). */
export const runMicrosoftUserSync = op("runMicrosoftUserSync");
